/* Load homepage categories without leaving the page */
(function () {
    if (!document.body.classList.contains('home-template')) return;

    const navigation = document.querySelector('.category-nav');
    const results = document.querySelector('.category-results');
    const links = Array.from(navigation?.querySelectorAll('.category-nav-item') || []);

    if (!navigation || !results || !links.length || navigation.dataset.dynamicCategoriesReady) return;

    navigation.dataset.dynamicCategoriesReady = 'true';

    let requestController;

    const setActiveLink = function (activeLink) {
        links.forEach(function (link) {
            const isActive = link === activeLink;
            link.classList.toggle('is-active', isActive);

            if (isActive) {
                link.setAttribute('aria-current', 'page');
            } else {
                link.removeAttribute('aria-current');
            }
        });
    };

    const loadCategory = async function (url, activeLink, pushHistory = true) {
        requestController?.abort();
        const controller = new AbortController();
        requestController = controller;

        results.classList.add('is-loading');
        results.setAttribute('aria-busy', 'true');

        try {
            const response = await fetch(url, {
                headers: {'Accept': 'text/html'},
                signal: controller.signal,
            });

            if (!response.ok) {
                throw new Error(`Category request failed: ${response.status}`);
            }

            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const incomingFeed = doc.querySelector('.gh-feed:not(.gh-featured):not(.gh-related)');
            const currentFeed = results.querySelector('.gh-feed');
            const currentTitle = results.querySelector('.gh-container-title');

            if (!incomingFeed || !currentFeed || !currentTitle) {
                throw new Error('Category response is missing its article list');
            }

            currentFeed.replaceChildren(...Array.from(incomingFeed.children).map(function (post) {
                return document.importNode(post, true);
            }));

            currentTitle.textContent = activeLink.textContent.trim() === '全部'
                ? document.documentElement.lang.startsWith('zh') ? '最新' : 'Latest'
                : activeLink.textContent.trim();

            setActiveLink(activeLink);

            if (pushHistory) {
                history.pushState({categoryUrl: url}, '', url);
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                window.location.assign(url);
            }
        } finally {
            if (!controller.signal.aborted) {
                results.classList.remove('is-loading');
                results.removeAttribute('aria-busy');
            }
        }
    };

    navigation.addEventListener('click', function (event) {
        const link = event.target.closest('.category-nav-item');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();
        loadCategory(link.href, link);
    });

    window.addEventListener('popstate', function () {
        const currentUrl = new URL(window.location.href);
        const activeLink = links.find(function (link) {
            return new URL(link.href).pathname === currentUrl.pathname;
        });

        if (activeLink) {
            loadCategory(currentUrl.href, activeLink, false);
        }
    });
})();
